import PropTypes from 'prop-types';
import React from 'react';
import StarRating from '../TherapistRating/star_rating';

const MAX_RATING = 5.0;

const GuestRating = props => {
  const { rating } = props;
  return (
    <div className="rating-space">
      <StarRating therapistRating={rating} maxRating={MAX_RATING} />
    </div>
  );
};

GuestRating.propTypes = {
  rating: PropTypes.number,
};

export default GuestRating;
